// IntegrationsSearch.js
import React from 'react';
import {
    Box,
    InputBase,
    IconButton
} from '@mui/material';
import { SearchIcon, CloseIcon } from 'icons/materialIcons';

const IntegrationsSearch = ({ searchTerm = '', onSearchChange }) => {
    const handleSearchChange = (event) => {
        onSearchChange(event.target.value);
    };

    const handleClearSearch = () => {
        onSearchChange('');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                backgroundColor: 'white',
                border: '1px solid #e3e3e3',
                borderRadius: '20px',
                px: 2,
                py: 1,
                mb: 3
            }}
        >
            <SearchIcon
                sx={{
                    color: '#828282',
                    mr: 1
                }}
            />

            <InputBase
                placeholder="Search 5000+ integrations"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{
                    flexGrow: 1,
                    fontSize: '0.875rem',
                    color: '#242020'
                }}
                fullWidth
            />

            {searchTerm && (
                <IconButton
                    size="small"
                    onClick={handleClearSearch}
                    sx={{
                        color: '#828282',
                        mr: 1
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        </Box>
    );
};

export default IntegrationsSearch;